/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc
 */
import * as References from './McpServerRegistryRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServerById
 */
export const GET_MCP_SERVER_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServerById';
export const GET_MCP_SERVER_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MCP_SERVER_BY_ID_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getMcpServerByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServers
 */
export const GET_MCP_SERVERS_QUERY_FIELD_NAME = 'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServers';
export const GET_MCP_SERVERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MCP_SERVERS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getMcpServersRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServersByAuthenticatorId
 */
export const GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY_FIELD_NAME = 'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServersByAuthenticatorId';
export const GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY_FIELD_NAME,
  args: ['authenticatorId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getMcpServersByAuthenticatorIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServerLogos
 */
export const GET_MCP_SERVER_LOGOS_QUERY_FIELD_NAME = 'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServerLogos';
export const GET_MCP_SERVER_LOGOS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MCP_SERVER_LOGOS_QUERY_FIELD_NAME,
  args: ['mcpServerIds'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getMcpServerLogosRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServersAvailableToPortal
 */
export const GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServersAvailableToPortal';
export const GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY_FIELD_NAME,
  args: ['search'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getMcpServersAvailableToPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServersByAppId
 */
export const GET_MCP_SERVERS_BY_APP_ID_QUERY_FIELD_NAME = 'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServersByAppId';
export const GET_MCP_SERVERS_BY_APP_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MCP_SERVERS_BY_APP_ID_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getMcpServersByAppIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServersAvailableToPortalPaginated
 */
export const GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY_FIELD_NAME = 'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServersAvailableToPortalPaginated';
export const GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY_FIELD_NAME,
  args: ['search', 'after', 'limit'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getMcpServersAvailableToPortalPaginatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});